import { parseOptionalCount } from '../acceptance/optionalCount';

/**
 * Frozen Scan verification work counts.
 *
 * toConfirm is unreviewed only. It is never total observations, evidence
 * queue length, or unresolved remainder.
 */
export type ScanVerificationProgressInput = {
  total?: number;
  unreviewed?: number;
  confirmed?: number;
  cleared?: number;
  unresolved?: number;
  complete?: boolean;
} | null | undefined;

export type ScanVerificationWorkCounts = {
  total: number;
  reviewed: number;
  confirmed: number;
  cleared: number;
  unresolved: number;
  unreviewed: number;
  toConfirm: number;
  complete: boolean;
};

function asCount(value: unknown): number {
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? Math.trunc(n) : 0;
}

export function presentScanVerificationWork(
  progress?: ScanVerificationProgressInput,
  fallback?: ScanVerificationProgressInput,
): ScanVerificationWorkCounts {
  const merged = { ...(fallback || {}), ...(progress || {}) };
  const total = asCount(merged.total);
  const unreviewed = asCount(merged.unreviewed);
  const confirmed = asCount(merged.confirmed);
  const cleared = asCount(merged.cleared);
  const unresolved = asCount(merged.unresolved);
  const reviewed = Math.max(0, total - unreviewed);
  const toConfirm = unreviewed;
  const complete = toConfirm <= 0 && (
    Boolean(merged.complete) || (total > 0 && reviewed === total)
  );
  return {
    total,
    reviewed,
    confirmed,
    cleared,
    unresolved,
    unreviewed,
    toConfirm,
    complete,
  };
}

/** Prefer frozen unreviewed, including 0, over queue/blocker totals. */
export function resolveScanVerifyPendingCount(args: {
  frozenUnreviewed?: number | null;
  frozenPending?: number | null;
  funnelPending?: number | null;
  blockerPending?: number | null;
}): number | null {
  const frozen = parseOptionalCount(args.frozenUnreviewed ?? args.frozenPending);
  if (frozen != null) return frozen;
  return parseOptionalCount(args.funnelPending) ?? parseOptionalCount(args.blockerPending);
}
